import { Button } from "@/components/ui/button";

interface UnsavedChangesBarProps {
  onKeep: () => void;
  onDiscard: () => void;
  onSave: () => void;
  saving?: boolean;
}

/** Shown when × , Close, the scrim or Esc would lose unsaved changes (#1559). */
export function UnsavedChangesBar({ onKeep, onDiscard, onSave, saving }: UnsavedChangesBarProps) {
  return (
    <div
      data-unsaved-bar
      role="alert"
      className="flex flex-wrap items-center gap-2 rounded-lg bg-status-warn-soft px-2.5 py-2 text-[13.5px] font-semibold text-status-warn"
    >
      You have unsaved changes.
      <span className="flex-1" />
      <Button type="button" variant="outline" size="sm" className="h-8 bg-card text-foreground" onClick={onKeep}>
        Keep editing
      </Button>
      <Button type="button" variant="outline" size="sm" className="h-8 bg-card text-status-hot border-status-hot-soft" onClick={onDiscard}>
        Discard changes
      </Button>
      <Button type="button" size="sm" className="h-8" onClick={onSave} disabled={saving}>
        Save and close
      </Button>
    </div>
  );
}
